import { useState } from 'react'

export type Region = 'Germany' | 'Spain' | 'UK' | 'France'
export type FilterType =
  | 'Wind'
  | 'Solar'
  | 'Temperature'
  | 'Weighting'
  | 'Capacity'
export type ViewType =
  | 'overview'
  | 'briefing'
  | 'oracle'
  | 'forecast'
  | 'benchmarks'
  | 'live-benchmarking'
  | 'market-aggregates'
  | 'trading-strategies'
  | 'dashboards'
  | 'map'
  | 'settings'
  | 'trading-strategies'

export type VariableType = 'Wind' | 'Solar' | 'Temperature'

export interface ZoneOption {
  name: string
  code: string
}

export function useDashboardState() {
  const [activeRegion, setActiveRegion] = useState<Region>('Germany')
  const [activeFilters, setActiveFilters] = useState<FilterType[]>([
    'Wind',
    'Capacity',
  ])
  const [searchQuery, setSearchQuery] = useState('')
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false)
  const [activeView, setActiveView] = useState<ViewType>('overview')
  const [activeZone, setActiveZone] = useState<ZoneOption>({
    name: 'Germany',
    code: 'DE',
  })
  const [activeVariable, setActiveVariable] = useState<VariableType>('Wind')

  const toggleFilter = (filter: FilterType) => {
    setActiveFilters((prev) =>
      prev.includes(filter)
        ? prev.filter((f) => f !== filter)
        : [...prev, filter],
    )
  }

  const toggleSidebar = () => setIsSidebarCollapsed((prev) => !prev)

  return {
    activeRegion,
    setActiveRegion,
    activeFilters,
    toggleFilter,
    searchQuery,
    setSearchQuery,
    isSidebarCollapsed,
    toggleSidebar,
    activeView,
    setActiveView,
    activeZone,
    setActiveZone,
    activeVariable,
    setActiveVariable,
  }
}
